import React, { useContext, useEffect } from "react";
import { IState } from "../../store/types";
import BattleContext from "../BattleContext";
import { styleClassName } from "../styleHelper";
import "./index.css";

const getStatus = (turn: number, maxTurn: number) => {
  let status = "";
  if (turn / maxTurn < 0.3) status = "is-error";
  else if (turn / maxTurn < 0.8) status = "is-warning";
  else if (turn / maxTurn <= 1) status = "is-primary";
  else status = "is-error";
  return status;
};

function TurnInfo({ turn }: { turn: IState["turn"] }) {
  const { battle: currentTurn, battleDuration: maxTurn } = turn;
  return (
    <div>
      <span className="nes-text is-primary">Turn: </span>
      <span className={`nes-text ${getStatus(currentTurn, maxTurn)}`}>
        {currentTurn}
      </span>
      <span>{` / ${maxTurn}`}</span>
    </div>
  );
}

const BATTLE_INTERVAL = 500;
function useAutoBattle(handler = () => {}) {
  const settings = useContext(BattleContext);
  const { isFirstTurn, autoBattle } = settings;
  useEffect(() => {
    let timerId: NodeJS.Timeout;
    // never set an interval the first turn (setup phase)
    if (!isFirstTurn && autoBattle)
      timerId = setInterval(handler, BATTLE_INTERVAL);
    return () => {
      clearInterval(timerId);
    };
  }, [isFirstTurn, autoBattle, handler]);
  return settings;
}

function TurnAutoBattle({ onClick }: { onClick: () => void }) {
  const settings = useAutoBattle(onClick);
  const { isFirstTurn, autoBattle, setAutoBattle } = settings;
  const disabled = !isFirstTurn && autoBattle;
  return (
    <div>
      <label htmlFor="battle-auto-turn">
        <input
          id="battle-auto-turn"
          type="checkbox"
          className={styleClassName("nes-checkbox")}
          checked={autoBattle}
          onChange={() => setAutoBattle(!autoBattle)}
        />
        <span>Auto</span>
      </label>
      <button
        type="button"
        disabled={disabled}
        className={`nes-btn is-primary ${disabled ? "is-disabled" : ""}`}
        onClick={onClick}
      >
        {isFirstTurn ? "Finish Setup" : "Next Turn"}
      </button>
    </div>
  );
}

interface IBattleEndTurn {
  onClick: () => void;
  turn: IState["turn"];
}

function BatttleEndTurn({ onClick = () => {}, turn }: IBattleEndTurn) {
  return (
    <div className="battle-end-turn">
      <TurnAutoBattle onClick={onClick} />
      <TurnInfo turn={turn} />
    </div>
  );
}

export default BatttleEndTurn;
